// import MetricCard from "../cards/MetricCard";
// import InfoCard from "../cards/InfoCard";
// export default function Overview() {
//   return (
//     <div className="d-flex flex-column gap-4">
//       {/* Top Metrics */}
//       <div className="row g-3">
//         <MetricCard title="Today's Sales" value="ETB 0.0" />
//         <MetricCard title="Today's Orders" value="0" />
//         <MetricCard title="Visitors" value="0" />
//         <MetricCard title="Sales Trend" value="📈 Chart" />
//       </div>

//       {/* Lower Section */}
//       <div className="row g-3">
//         <InfoCard title="Top Products" content="List of products" />
//         <InfoCard title="Stock Alerts" content="Based on SKUs" />
//         <InfoCard title="Messages" content="No unread messages" />
//       </div>
//     </div>
//   );
// }

// import MetricCard from "../cards/MetricCard";
// import InfoCard from "../cards/InfoCard";
// import RecentOrdersTable from "../tables/RecentOrdersTable";
// import SalesChart from "../charts/SalesChart";

// export default function Overview() {
//   return (
//     <div className="container-fluid d-flex flex-column gap-4">
//       {/* ================= KPI SECTION ================= */}
//       <div className="row g-4">
//         <div className="col-12 col-md-6 col-xl-3">
//           <MetricCard
//             title="Today's Revenue"
//             value="ETB 12,540"
//             change="+12.4%"
//             changeType="positive"
//             subtitle="vs yesterday"
//             icon="currency"
//           />
//         </div>

//         <div className="col-12 col-md-6 col-xl-3">
//           <MetricCard
//             title="Today's Orders"
//             value="38"
//             change="+8.2%"
//             changeType="positive"
//             subtitle="vs yesterday"
//             icon="orders"
//           />
//         </div>

//         <div className="col-12 col-md-6 col-xl-3">
//           <MetricCard
//             title="Conversion Rate"
//             value="3.4%"
//             change="-0.6%"
//             changeType="negative"
//             subtitle="vs last week"
//             icon="conversion"
//           />
//         </div>

//         <div className="col-12 col-md-6 col-xl-3">
//           <MetricCard
//             title="Visitors"
//             value="1,284"
//             change="+4.1%"
//             changeType="positive"
//             subtitle="last 24 hours"
//             icon="users"
//           />
//         </div>
//       </div>

//       {/* ================= SALES CHART ================= */}
//       <div className="row g-4">
//         <div className="col-12 col-xl-8">
//           <InfoCard title="Revenue Analytics (Last 7 Days)">
//             <SalesChart />
//           </InfoCard>
//         </div>

//         <div className="col-12 col-xl-4">
//           <InfoCard title="Performance Summary">
//             <div className="d-flex flex-column gap-3">
//               <div className="d-flex justify-content-between">
//                 <span>Total Revenue</span>
//                 <strong>ETB 248,500</strong>
//               </div>
//               <div className="d-flex justify-content-between">
//                 <span>Total Orders</span>
//                 <strong>1,284</strong>
//               </div>
//               <div className="d-flex justify-content-between">
//                 <span>Average Order Value</span>
//                 <strong>ETB 193.6</strong>
//               </div>
//               <div className="d-flex justify-content-between">
//                 <span>Pending Orders</span>
//                 <strong className="text-warning">12</strong>
//               </div>
//               <div className="d-flex justify-content-between">
//                 <span>Refund Requests</span>
//                 <strong className="text-danger">3</strong>
//               </div>
//             </div>
//           </InfoCard>
//         </div>
//       </div>

//       {/* ================= LOWER SECTION ================= */}
//       <div className="row g-4">
//         <div className="col-12 col-xl-8">
//           <InfoCard title="Recent Orders">
//             <RecentOrdersTable />
//           </InfoCard>
//         </div>

//         <div className="col-12 col-xl-4">
//           <InfoCard title="Low Stock Alerts">
//             <div className="d-flex flex-column gap-3">
//               <div className="d-flex justify-content-between align-items-center">
//                 <div>
//                   <div className="fw-semibold">Wireless Headphones</div>
//                   <small className="text-muted">SKU: WH-1023</small>
//                 </div>
//                 <span className="badge bg-danger">3 left</span>
//               </div>

//               <div className="d-flex justify-content-between align-items-center">
//                 <div>
//                   <div className="fw-semibold">Smart Watch X</div>
//                   <small className="text-muted">SKU: SW-4412</small>
//                 </div>
//                 <span className="badge bg-warning text-dark">8 left</span>
//               </div>

//               <div className="text-end">
//                 <button className="btn btn-sm btn-outline-primary">
//                   Manage Inventory
//                 </button>
//               </div>
//             </div>
//           </InfoCard>
//         </div>
//       </div>
//     </div>
//   );
// }

import MetricCard from "../cards/MetricCard";
import InfoCard from "../cards/InfoCard";
import RecentOrdersTable from "../tables/RecentOrdersTable";
import SalesChart from "../charts/SalesChart";

export default function Overview() {
  return (
    <div className="container-fluid d-flex flex-column gap-4">
      {/* ================= PRIMARY KPI SECTION ================= */}
      <div className="row g-4">
        <div className="col-12 col-md-6 col-xl-3">
          <MetricCard
            title="Today's Revenue"
            value="ETB 12,540"
            change="+12.4%"
            changeType="positive"
            subtitle="vs yesterday"
            icon="currency"
          />
        </div>

        <div className="col-12 col-md-6 col-xl-3">
          <MetricCard
            title="Today's Orders"
            value="38"
            change="+8.2%"
            changeType="positive"
            subtitle="vs yesterday"
            icon="orders"
          />
        </div>

        <div className="col-12 col-md-6 col-xl-3">
          <MetricCard
            title="Conversion Rate"
            value="3.4%"
            change="-0.6%"
            changeType="negative"
            subtitle="vs last week"
            icon="conversion"
          />
        </div>

        <div className="col-12 col-md-6 col-xl-3">
          <MetricCard
            title="Visitors"
            value="1,284"
            change="+4.1%"
            changeType="positive"
            subtitle="last 24 hours"
            icon="users"
          />
        </div>
      </div>

      {/* ================= ADVANCED KPI SECTION ================= */}
      <div className="row g-4">
        <div className="col-12 col-md-6 col-xl-3">
          <MetricCard
            title="Average Order Value"
            value="ETB 193.6"
            change="+3.2%"
            changeType="positive"
            subtitle="vs last month"
            icon="aov"
          />
        </div>

        <div className="col-12 col-md-6 col-xl-3">
          <MetricCard
            title="Net Revenue"
            value="ETB 11,820"
            change="+9.1%"
            changeType="positive"
            subtitle="after refunds"
            icon="net"
          />
        </div>

        <div className="col-12 col-md-6 col-xl-3">
          <MetricCard
            title="Refund Rate"
            value="1.8%"
            change="-0.3%"
            changeType="positive"
            subtitle="lower is better"
            icon="refund"
          />
        </div>

        <div className="col-12 col-md-6 col-xl-3">
          <MetricCard
            title="Inventory Health"
            value="92%"
            change="-2%"
            changeType="negative"
            subtitle="stock availability"
            icon="inventory"
          />
        </div>
      </div>

      {/* ================= SALES + PERFORMANCE ================= */}
      <div className="row g-4">
        <div className="col-12 col-xl-8">
          <InfoCard title="Revenue Analytics (Last 7 Days)">
            <SalesChart />
          </InfoCard>
        </div>

        <div className="col-12 col-xl-4">
          <InfoCard title="Operational Performance">
            <div className="d-flex flex-column gap-3">
              <div className="d-flex justify-content-between">
                <span>Total Revenue</span>
                <strong>ETB 248,500</strong>
              </div>

              <div className="d-flex justify-content-between">
                <span>Total Orders</span>
                <strong>1,284</strong>
              </div>

              <div className="d-flex justify-content-between">
                <span>Fulfillment Rate</span>
                <strong className="text-success">98.2%</strong>
              </div>

              <div className="d-flex justify-content-between">
                <span>Pending Orders</span>
                <strong className="text-warning">12</strong>
              </div>

              <div className="d-flex justify-content-between">
                <span>Canceled Orders</span>
                <strong className="text-danger">4</strong>
              </div>

              <div className="d-flex justify-content-between">
                <span>Refund Requests</span>
                <strong className="text-danger">3</strong>
              </div>

              <div className="d-flex justify-content-between">
                <span>New Customers</span>
                <strong>124</strong>
              </div>

              <div className="d-flex justify-content-between">
                <span>Returning Customers</span>
                <strong>38%</strong>
              </div>
            </div>
          </InfoCard>
        </div>
      </div>

      {/* ================= LOWER SECTION ================= */}
      <div className="row g-4">
        <div className="col-12 col-xl-8">
          <InfoCard title="Recent Orders">
            <RecentOrdersTable />
          </InfoCard>
        </div>

        <div className="col-12 col-xl-4">
          <InfoCard title="Low Stock Alerts">
            <div className="d-flex flex-column gap-3">
              <div className="d-flex justify-content-between align-items-center">
                <div>
                  <div className="fw-semibold">Wireless Headphones</div>
                  <small className="text-muted">SKU: WH-1023</small>
                </div>
                <span className="badge bg-danger">3 left</span>
              </div>

              <div className="d-flex justify-content-between align-items-center">
                <div>
                  <div className="fw-semibold">Smart Watch X</div>
                  <small className="text-muted">SKU: SW-4412</small>
                </div>
                <span className="badge bg-warning text-dark">8 left</span>
              </div>

              <div className="text-end">
                <button className="btn btn-sm btn-outline-primary">
                  Manage Inventory
                </button>
              </div>
            </div>
          </InfoCard>
        </div>
      </div>
    </div>
  );
}
